import { Text, Textarea } from '@chakra-ui/react';

const Notes = ({ register, notesTextLength, canEditTracking }) => (
  <div className="row d-flex align-items-center my-2">
    <div className="col-12 col-md-4">
      <p className="fw-bold mb-0">Orientações para rastreio</p>
    </div>
    <div className="col-12 col-md-8">
      <Textarea
        type="text"
        rows={5}
        disabled={!canEditTracking}
        placeholder="Forneça as instruções necessárias para que o lojista realize o rastreio da entrega."
        {...register('trackingInstructions', { maxLength: 500 })}
      />
      {canEditTracking && <Text>{notesTextLength}/500</Text>}
    </div>
  </div>
);

export default Notes;
